
































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import PointInformationCard from './PointInformationCard.vue';

interface MenuThanks {
  lang: string;
  path: string;
}

@Component<SideBarPc>({
  components: { PointInformationCard, CSideBar },
})
export default class SideBarPc extends Vue {
  @Prop({ type: Boolean })
  value: boolean;

  filters: MenuThanks[] = [
    { lang: 'thanks.filter.all', path: '/thanks/all' },
    { lang: 'thanks.filter.forYou', path: '/thanks/for-you' },
    { lang: 'thanks.filter.fromMe', path: '/thanks/from-me' },
  ];
}
